import { Link } from 'react-router-dom'
import { Users, UserCheck, Globe, Archive, AlertTriangle } from 'lucide-react'
import { useAuth } from '@/context/AuthContext'
import { ROLES, isSuperAdminOrOwner } from '@jira-clone/shared-types'

export type LeadsSection = 'all' | 'overdue' | 'assignee' | 'source' | 'archive'

const ACTIVE = 'px-3 py-1.5 text-xs font-semibold rounded-lg bg-primary text-primary-foreground shadow-sm flex items-center gap-1.5'
const IDLE =
  'px-3 py-1.5 text-xs font-medium rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground flex items-center gap-1.5 transition-colors'

// Section tabs shared by every Leads page so they can't drift apart.
export function LeadsSubNav({ current }: { current: LeadsSection }) {
  const { user } = useAuth()
  // Leads by Assignee is ADMIN-tier (team-wide visibility, same gate as the
  // sidebar nav item in AppLayout.tsx) - MEMBER/VIEWER always 403 on the
  // route itself, so the tab shouldn't be shown to them in the first place.
  const canViewLeadsByAssignee = isSuperAdminOrOwner(user?.role) || user?.role === ROLES.ADMIN
  const cls = (section: LeadsSection) => (current === section ? ACTIVE : IDLE)

  return (
    <div className="flex items-center gap-2 border-b border-border pb-3">
      <Link to="/app/leads" className={cls('all')}>
        <Users className="h-3.5 w-3.5" /> All Leads
      </Link>
      <Link to="/app/leads/overdue" className={cls('overdue')}>
        <AlertTriangle className="h-3.5 w-3.5" /> Overdue Follow-ups
      </Link>
      {canViewLeadsByAssignee && (
        <Link to="/app/leads/assignee" className={cls('assignee')}>
          <UserCheck className="h-3.5 w-3.5" /> Leads by Assignee
        </Link>
      )}
      <Link to="/app/leads/source" className={cls('source')}>
        <Globe className="h-3.5 w-3.5" /> Leads By Source
      </Link>
      <Link to="/app/leads/archive" className={cls('archive')}>
        <Archive className="h-3.5 w-3.5" /> Archive
      </Link>
    </div>
  )
}
